import axios, { AxiosResponse } from "axios"
import { checkResponseStatus } from "./Utils"

export const login = async (username: string, password: string) =>{
    try {
        await axios.post('api/auth/login', {username, password})
        return
    } catch(error:any) {
        throw error
    }
}

export const autoLogin = async (username: string, token: string) =>{
    try {
        await axios.post('api/auth/login-auto', {username, token})
        return
    } catch(error:any) {
        throw error
    }
}

export const logout = async () =>{
    try {
        await axios.post('api/auth/logout')
        return
    } catch(error:any) {
        throw error
    }
}

export const getSession = async () =>{
    try {
        const response = await axios.get('api/auth/get-session')
        return response.data
    } catch(error:any) {
        throw error
    }
}

export const getEnvironment = async () =>{
    try {
        const response = await axios.get('api/auth/get-environment')
        return response.data
    } catch(error:any) {
        throw error
    }
}

export const healthCheck = async () =>{
    try {
        const response = await axios.get('api/auth/health-check')
        return response.data
    } catch(error:any) {
        throw error
    }
}

export const autoGenerateBecommerceLink = async(userId: string, shopId: string)=>{
    try {
        const response: AxiosResponse<{link: string},any> = await axios.get(`api/auth/becommerce/generate-link?userId=${userId}&shopId=${shopId}`)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const sendBeCommerceInvitationLink = async(userId: string, shopId: string) =>{
    try{
        const response: AxiosResponse<unknown,any> = await axios.post(`api/auth/becommerce/send-invitation?userId=${userId}&shopId=${shopId}`)
        return response.data
    } catch(error: any) {
        checkResponseStatus(error)
        throw error
    }
}

export const sendUserPasswordRequest = async(username:string, origin:string) => {
    try {
        const response = await axios.post('api/auth/request-password-reset', {origin, username})
        return response.data
    } catch(error:any) {
        throw error
    }
}

export const resetPassword = async(username:string, token:string, newPassword:string) => {
    try {
        const response = await axios.post('api/auth/reset-password', {username, token, newPassword})
        return response.data
    } catch(error:any) {
        throw error
    }
}
